import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { PureComponent } from 'react';
import { isQuerySelected } from '../utils/rtk-query.js';
const queryStatusCss = (theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 22,
    padding: '0 6px',
    borderRadius: '3px',
    fontSize: '0.7em',
    lineHeight: '1em',
    flexShrink: 0,
    fontWeight: 700,
    backgroundColor: theme.ACTION_TIME_BACK_COLOR,
    color: theme.ACTION_TIME_COLOR,
});
export class QueryList extends PureComponent {
    static isItemSelected(selectedQueryKey, queryInfo) {
        return (!!selectedQueryKey &&
            selectedQueryKey.queryKey === queryInfo.queryKey &&
            selectedQueryKey.reducerPath === queryInfo.reducerPath);
    }
    static formatQuery(resInfo) {
        const key = resInfo.type === 'query'
            ? resInfo.queryKey
            : `${resInfo.state.endpointName ?? ''} ${resInfo.queryKey}`;
        return key;
    }
    render() {
        const { resInfos, selectedQueryKey, onSelectQuery } = this.props;
        return (_jsx("ul", { css: { listStyle: 'none', margin: '0', padding: '0' }, children: resInfos.map((resInfo) => {
                const isSelected = isQuerySelected(selectedQueryKey, resInfo);
                return (_jsxs("li", { onClick: () => onSelectQuery(resInfo), css: [
                        (theme) => ({
                            borderBottomWidth: '1px',
                            borderBottomStyle: 'solid',
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '5px 10px',
                            cursor: 'pointer',
                            userSelect: 'none',
                            '&:last-child': {
                                borderBottomWidth: 0,
                            },
                            overflow: 'hidden',
                            maxHeight: 47,
                            borderBottomColor: theme.BORDER_COLOR,
                        }),
                        isSelected &&
                            ((theme) => ({
                                backgroundColor: theme.SELECTED_BACKGROUND_COLOR,
                            })),
                    ], children: [_jsx("p", { css: {
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2,
                                whiteSpace: 'normal',
                                overflow: 'hidden',
                                width: '100%',
                                maxWidth: 'calc(100% - 70px)',
                                wordBreak: 'break-all',
                                margin: 0,
                            }, children: QueryList.formatQuery(resInfo) }), _jsxs("div", { css: {
                                display: 'flex',
                                width: 'auto',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: 0,
                                flex: '0 0 auto',
                                overflow: 'hidden',
                            }, children: [_jsx("strong", { css: [queryStatusCss, { marginRight: 4 }], children: resInfo.type === 'query' ? 'Q' : 'M' }), _jsx("p", { css: queryStatusCss, children: resInfo.state.status })] })] }, resInfo.queryKey));
            }) }));
    }
}
